export default class CartItem extends HTMLElement {
	constructor() {
		super();
  }
  
  get product () { 
    return JSON.parse(this.getAttribute('product'));
  }
  set product (val){
    this.setAttribute('product', JSON.stringify(val));
  }
  get quantity () { 
    return this._quantity;
  }
  set quantity (val){
    this._quantity = parseInt(val);
    this.updateQuantitySelector();
  }
  get price () { 
    return this._price;
  }
  set price (val){
    this._price = val;
    this.updatePrice();
  }

  updateQuantitySelector(){
    if (this.querySelector('select')) {
      this.querySelector('select').value = this.quantity;
      this.querySelector('.custom-select').innerHTML = this.quantity;
    }
  }

  updatePrice(){
    if (this.querySelector('.price')) {
      this.querySelector('.price').innerHTML = this.price;
    }
  }

  static get observedAttributes() {
    return ['quantity', 'price'];
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    if (attr === 'quantity' || attr === 'price') {
      this[attr] = newVal;
    }
  }

	connectedCallback() {
    // Invoked each time the custom element is appended into DOM.

    this.productcolor = this.getAttribute('productcolor'); 
    this.sku = this.getAttribute('sku');
    this.renderTemplate();

    // Respond to `productsLoaded` event and send the cart data to update the product cards 
    var cartItem = this;
    const sizePicker = document.querySelector("size-picker")
    if (sizePicker) {      
      sizePicker.addEventListener('productsLoaded', (event => {
          var callbackFn = event.detail.callback;
          var cartObj = {sku: cartItem.sku, quantity: cartItem.quantity}
          callbackFn(cartObj);
      }));
    }

    this.querySelector('select').addEventListener('change', (event => {
      var selectedValue = this.querySelector('select').value;
      if (selectedValue == "remove"){
        this.style.display = 'none'
        this.dispatchEvent(new CustomEvent("ItemRemoved", {
          detail: { 
            sku: this.sku
          }
        }));
      } 
      else {
        cartItem.price = '...';
        // Showing the modified quantity immediately for visual feedback here.
        // The actual quantity change happens after `this.quantity` is set from the cart component.
        this.querySelector('.custom-select').innerHTML = selectedValue;
        let selectedQty = parseInt(selectedValue);
        this.dispatchEvent(new CustomEvent("ItemQuantityChanged", {
          detail: { 
            qty: selectedQty,
            sku: this.sku
          }
        }));
      }
   }));
  }

  disconnectedCallback() {
    // Invoked each time the custom element is disconnected from the document's DOM.
  }

  renderTemplate(){
    // console.log(this.getAttribute('product'))
    const cartItemTemplate = document.createElement('template');
    cartItemTemplate.innerHTML = `
        <div class="card cart-item slider-item">
        <div class="product-thumbnail">
          <img src="${this.product.thumbnail}"/>
        </div>
        <div class="product-info">
          <p class="title">${(this.product.type != 'fom' && this.product.type != 'supply') ? this.product.type_name : this.product.name}</p>
          <p class="footnote details">
            ${(()=>{
              if(['lintroller', 'lintroller-refill'].includes(this.product.type)){
                  return `${this.product.style} <br>${this.product.size} <br><p class="caps price">${this.price}</p>`
              }
              else if (['mask', 'beanie', 'apron', 'towel', 'mug'].includes(this.product.type)){
                  return `${this.product.name} <br>${this.product.size} <br><p class="caps price">${this.price}</p>`
              }
              else if (['fom'].includes(this.product.type)){
                  return `${this.product.type_name}`
              }
              else if (['supply'].includes(this.product.type)){
                return `${this.product.style.toLowerCase() !== 'unknown' ? this.product.style + ' <span class="seperator">•</span>' : ''} ${this.product.size} <br><p class="caps price">${this.price}</p>`
              }
              else{
                return `${this.product.name} ${this.product.is_pack && this.product.subnames.length > 0 ? '<br>' + this.product.subnames.join(' <span class="middot">&middot;</span> ') : ''} <br>${this.product.style.toLowerCase() !== 'unknown' ? this.product.style + ' <span class="seperator">•</span>' : ''} ${this.product.size} <br><p class="caps price">${this.price}</p>`
              }
          })()}
          </p>
        </div>
        <div class="quantity-picker">
          <div class="custom-select-wrapper caps">
            <select class="default-select">
              <option value="remove">Remove</option>
              <option value="1" ${this.quantity==1?'selected':''}>1</option>
              <option value="2" ${this.quantity==2?'selected':''}>2</option>
              <option value="3" ${this.quantity==3?'selected':''}>3</option>
              <option value="4" ${this.quantity==4?'selected':''}>4</option>
              <option value="5" ${this.quantity==5?'selected':''}>5</option>
              <option value="6" ${this.quantity==6?'selected':''}>6</option>
              <option value="7" ${this.quantity==7?'selected':''}>7</option>
              <option value="8" ${this.quantity==8?'selected':''}>8</option>
              <option value="9" ${this.quantity==9?'selected':''}>9</option>
            </select>
            <div class="custom-select" style="background:${this.productcolor}">${this.quantity}</div>
          </div>
        </div>
      </div>
      `;
    this.appendChild(cartItemTemplate.content.cloneNode(true));
  }
}
window.customElements.define('cart-item', CartItem);
